/* eslint-disable */
import React, { useState } from "react";
import AdminTableLeave from "./components/adminTable/adminTable";
import AdminLeaveCard from "./components/adminCard/adminCard";
import { Button, Group, Title } from "@mantine/core";
import { UserPlus } from "tabler-icons-react";
import { PermissionButton } from "api/permission/buttonpermission";
import UserBalanceUpdateModal from "./components/adduserBalance/adduserbalance";

export default function AdminLeave() {
  const [opened, setOpened] = useState(false);
  return (
    <div>
      <Group position="apart" mb="md">
        <Title order={2}>Admin Leave</Title>
        {/* <Group>
          <PermissionButton
            permission="employees.userBalance"
            leftIcon={<UserPlus size={16} />}
            onClick={() => setOpened(true)}
          >
            Add User Balance
          </PermissionButton>
        </Group> */}
      </Group>
      <AdminLeaveCard />

      <div style={{ width: "100%" }}>
        {" "}
        <AdminTableLeave />
      </div>

      <UserBalanceUpdateModal
        opened={opened}
        onClose={() => setOpened(false)}
      />
    </div>
  );
}
